import { jsx as ___EmotionJSX } from "@emotion/core";
import React from 'react';
import { I18nextProvider, initReactI18next } from 'react-i18next';
import i18n from 'i18next';
import { useLocale } from '../useLocale';
i18n.use(initReactI18next) // passes i18n down to react-i18next
.init({
  lng: 'en',
  defaultNS: 'common',
  initImmediate: false,
  keySeparator: false,
  interpolation: {
    escapeValue: false // react already safes from xss

  },
  saveMissing: true,
  missingKeyHandler: function missingKeyHandler(lngs, ns, key, fallbackValue) {
    //console.log(`missing key in i18n ${ns}:${key}`)
    return fallbackValue;
  },
  react: {
    wait: true
  }
});
export function changeLocale(locale) {
  if (locale !== i18n.language) {
    i18n.changeLanguage(locale);
  }
}
export function addResourceSet(locale, name, items) {
  if (!i18n.hasResourceBundle(locale, name)) {
    items.forEach(function (item) {
      return i18n.addResource(locale, name, item.key, item.text, {
        silent: true
      });
    });
  }
}
export function removeResourceSet(locale, name) {
  if (i18n.hasResourceBundle(locale, name)) {
    i18n.removeResourceBundle(locale, name);
  }
}

var I18nProvider = function I18nProvider(_ref) {
  var children = _ref.children;

  var _useLocale = useLocale(),
      locale = _useLocale.locale;

  React.useEffect(function () {
    changeLocale(locale);
  }, [locale]);
  return ___EmotionJSX(I18nextProvider, {
    i18n: i18n
  }, children);
};

export default I18nProvider;